import classNames from 'classnames'
import { forwardRef } from 'react'
import { Link } from 'react-router'

import styles from './button.module.css'
import { ButtonProps } from './button.type'
import { buttonSize, buttonVariant } from './constants'
import Icon from '../icon/Icon'

const Button = forwardRef<HTMLElement, ButtonProps>(function Button({
    children,
    size = buttonSize.large,
    variant = buttonVariant.primary,
    width,
    icon,
    animation,
    onClick,
    type,
    href,
    disabled,
    inverted,
    className,
    container: containerProp,
    ...rest
}, ref) {
    const buttonClassNames = classNames(
        styles.button,
        size,
        variant === 'primary' ? styles.buttonVariantPrimary : styles.buttonVariantSecondary,
        width,
        className,
    )

    const iconClassName = size === buttonSize.large ? styles.iconLarge : styles.iconSmall
    
    const getContainer = () => {
        if (containerProp) return containerProp
        if (!href && (onClick || disabled || type === "submit")) return "button"
        if (href) return Link
        return "div"
    }

    const Container = getContainer()

    const props = {
        className: buttonClassNames,
        to: href,
        onClick: onClick,
        disabled: Container === 'button' ? disabled : undefined,
        'data-disabled': disabled,
        'data-inverted': inverted,
        ref: ref,
        ...rest,
    }

    const content = icon ?
        [<Icon icon={ icon } key={ 1 } className={ iconClassName } animation={ animation } />, children]
        :
        children

    return (
        <Container { ...props }>
            <span className={ styles.contentWrapper }>{ content }</span>
        </Container>
    )
})


export default Button
